<template>
    <div class="alternate-form-component" :class="classes">
        <!-- <label
            v-if="!isHidden"
            class="alternate-form-component__label"
            :class="!isFilled && !isFocused && state !== 'error' ? 'alternate-form-component__label--hidden' : null"
            :for="name"
            >{{ label }} <template v-if="required">*</template>
        </label> -->
        <slot>
            <input
                :id="name"
                class="alternate-form-component__input"
                :type="type"
                :pattern="pattern"
                :inputmode="inputmode"
                :value="value"
                :name="name"
                :placeholder="inputPlaceholder"
                :disabled="disabled"
                @focus="focusHandler"
                @blur="blurHandler"
                @input="update"
            />
        </slot>
        <label v-if="!isHidden && hint" class="alternate-form-component__hint" :for="name">{{ hint }}</label>
    </div>
</template>

<script>
import './alternate-form-component.scss';

export default {
    name: 'AlternateFormComponent',
    props: {
        name: {
            type: String,
            default: 'name',
        },
        label: {
            type: String,
            default: 'label',
        },
        placeholder: {
            type: String,
            default: '',
        },
        hint: {
            type: String,
            default: '',
        },
        value: {
            required: true,
            default: '',
        },
        type: {
            type: String,
            default: 'text',
        },
        pattern: {
            type: String,
        },
        inputmode: {
            type: String,
        },
        required: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        state: {
            type: String,
            default: 'default',
            validator: function(val) {
                return ['default', 'error'].includes(val);
            },
        },
    },
    data() {
        return {
            isFocused: false,
        };
    },
    computed: {
        inputPlaceholder() {
            let placeholder = this.placeholder;
            if (this.required) {
                placeholder += ' *';
            }
            if (this.isFocused) {
                placeholder = '';
            }

            return placeholder;
        },
        isFilled() {
            return this.value !== '';
        },
        isHidden() {
            return this.type === 'hidden';
        },
        classes() {
            let classes = [];
            if (this.isFocused) classes.push('scc-form-component--focused');
            if (this.isFilled) classes.push('scc-form-component--filled');
            classes.push(`scc-form-component--${this.state}`);
            return classes;
        },
    },
    methods: {
        update(e) {
            this.$emit('input', e.target.value);
        },
        focusHandler() {
            this.isFocused = true;
        },
        blurHandler(e) {
            this.$emit('blur', e);
            this.isFocused = false;
        },
    },
};
</script>
